import { render, staticRenderFns } from "./SelectPaymentAfr.vue?vue&type=template&id=23f8219f&scoped=true&"
import script from "./SelectPaymentAfr.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentAfr.vue?vue&type=script&lang=js&"
import style0 from "./SelectPaymentAfr.vue?vue&type=style&index=0&id=23f8219f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8219f",
  null
  
)

export default component.exports